import { InteractiveTable, InteractiveTableCellProps } from '@dreryk/react-components';

type ExcessiveCheckboxProps = InteractiveTableCellProps<boolean>;

export const ExcessiveCheckboxCell = (props: ExcessiveCheckboxProps): JSX.Element => {
   return (
      <InteractiveTable.CheckboxCell
         testId={props.testId}
         name={props.name}
         index={props.index}
         defaultValue={props.defaultValue}
      />
   );
};
